import { useWoody } from '../../woody/woody.js';
import { useMutation } from '@tanstack/react-query';
import { mutate } from 'swr';
import { useQueryUserInfo } from '../queries/useQueryUserInfo.js';

const useMutationUpdateUserOnboarding = () => {
  const { client } = useWoody();
  const { refetch } = useQueryUserInfo({
    enabled: false
  });
  return useMutation({
    mutationFn: async ({ body }) => {
      return await client.v2("/v2/user-onboarding", {
        method: "patch",
        body
      });
    },
    onMutate: async ({ body, user: providedUser }) => {
      const user = providedUser ?? (await refetch()).data;
      if (!user) return;
      mutate("woody-user", {
        ...user,
        onboarding: {
          ...user.onboarding,
          ...body
        }
      }, false);
      return {
        user
      };
    },
    onSuccess: (_, body, { user }) => {
      mutate("woody-user", {
        ...user,
        onboarding: {
          ...user.onboarding,
          ...body
        }
      });
    },
    onError: (_, _v, ctx) => {
      if (ctx?.user) mutate("woody-user", {
        ...ctx.user
      });
    }
  });
};

export { useMutationUpdateUserOnboarding };
//# sourceMappingURL=useMutationUpdateUserOnboarding.js.map
